<template>
  <div class="past-month-chart">
    <h3 class="title">24-hr PSI in the past 30 days</h3>
    <responsive-svg v-slot="sizing" padding="0 1% 20">
      <bar-chart v-bind="sizing" v-if="data && data[active]"
        :data="data[active].slice(1)"
        x="label"
        y="value"
        c="class"
        :y-domain="yDomain"
        :padding="0.25"
        :x-format="xFormat">
        <!-- <template v-slot:clip="{xScale, yScale}">
          <path v-bind="clipPathAttrs(data[active], xScale, yScale)" v-morph></path>
        </template> -->
      </bar-chart>
    </responsive-svg>
  </div>
</template>

<script>
import ResponsiveSvg from 'vue-graphics/hocs/ResponsiveSvg'
import Morph from 'vue-graphics/animation/directives/v-morph'
import BarChart from './BarChart'

import line from 'd3-shape/src/line'
import curveLinear from 'd3-shape/src/curve/linear'
import {scalePoint} from 'd3-scale'

export default {
  components: {
    ResponsiveSvg,
    BarChart
  },
  directives: {
    Morph
  },
  props: ['data', 'active'],
  computed: {
    yDomain () {
      let highest = 0
      Object.values(this.data).forEach(data => {
        data.forEach(row => {
          if (row.value > highest) highest = row.value
        })
      })
      return [0, highest]
    }
  },
  methods: {
    xFormat (label, i) {
      if (i === 0) return formatDate(label[1])
      if ([15, 30].includes(i)) return formatDate(label[0])
      return null
    },
    clipPathAttrs (data, xScale, yScale) {
      const first = Object.assign({}, data[0], {value: 0})
      const last = Object.assign({}, data[data.length - 1], {value: 0})
      const _xScale = scalePoint()
        .domain(data.map(d => d.label))
        .range(xScale.range())
      const lineGenerator = line()
        .x(d => _xScale(d.label))
        .y(d => yScale(d.value))
        .curve(curveLinear)
      return {
        d: lineGenerator([first, ...data, last]) + 'Z'
      }
    }
  }
}

const MONTHS = ['Jan', 'Feb', 'March', 'April', 'May', 'June', 'July', 'Aug', 'Sept', 'Oct', 'Nov', 'Dec']

function formatDate (t) {
  const d = new Date(t)
  return d.getDate() + ' ' + MONTHS[d.getMonth()]
}
</script>

<style lang="scss">
.past-month-chart {
  .title {
    font-size: 15px;
    line-height: 30px;
    margin: 0;
  }

  svg {
    display: block;
    width: 100%;
    height: 80px;
    box-sizing: border-box;
  }

  .vg-tick {
    text {
      font-size: 13px;
      color: $black;
      opacity: 0.5;
    }

    &:first-child {
      text {
        text-anchor: start;
      }
    }

    &:last-child {
      text {
        text-anchor: end;
      }
    }
  }

  .vg-area {
    stroke: none;
    fill: #000;
  }

  .vg-bar {
    stroke: none;
  }

  .good {
    fill: #68a94b;
  }

  .moderate {
    fill: #6b9dcf;
  }

  .unhealthy {
    fill: #f8d448;
  }

  .very-unhealthy {
    fill: #d4883d;
  }

  .hazardous {
    fill: #dd5034;
  }

  .vg-text-label.latest {
    font-family: $font-CuratorBold;
    font-size: 13px;
  }
}
</style>
